// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2KJr4","content":"RecentSearches_content__1kMOR"};